import { StubPage } from '../StubPage'
export function Documents() {
  return <StubPage title="Documents" summary="Documents are files stored inside a Dataset. Each document has a MIME type, size, and optional archival date. Documents can be downloaded via a signed URL and are automatically purged after the archival period expires." />
}
